import { PartType } from '@/partTypes'
import { IStateType } from '@/store/types'
import type { Store } from 'vuex'

// 转换数据，需要将绘制数据中的某些值进行转换，避免直接操作绘制的方法
export const transformData = (part: PartType, store: Store<IStateType>) => {
  const partTemp = { ...part }
  // 开启了异形自动选刀
  const isInnerShapeAutoSelectKnife =
    store.state.preferencesSetting?.setting.inner_shape_tool_match
  const { curveHoles: curveHolesTemp } = partTemp
  if (isInnerShapeAutoSelectKnife) {
    const curveHoles = curveHolesTemp?.map((curveHole: any) => {
      return {
        ...curveHole,
        path: curveHole.path?.length
          ? curveHole.path
          : curveHole['native_path'],
      }
    })
    partTemp['curveHoles'] = curveHoles || curveHolesTemp
  }
  return partTemp
}
